// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2s46l","productName":"Table_productName__1Dzc4"};